import api from '@/api/index'
import config from '@/config'

export const accountApi = {
    getCode: (params) => {
        return api.sendPostRequest('/llm/user/sendMsg', params)
    },
    login: (params) => {
        return api.sendPostRequest('/llm/user/login', params)
    },
    getUserInfo: () => {
        return api.sendGetRequest('/llm/user/getUserInfo')
    },
    resetPw: (params: ResetPwParams) => {
        return api.sendPostRequest('/llm/user/resetPw', params)
    },
    // 获取体验用户手机验证码
    getTasteUserMobileCaptcha: (params) => {
        return api.sendPostRequest(config.ossUrl() + '/official/getTasteUserMobileCaptcha', params)
    },
    // 添加体验用户
    addTasteUser: (params: postOfficialAddTasteUserBodyParams) => {
        return api.sendPostRequest(config.ossUrl() + '/official/addTasteUser', params)
    },
    // 更新客户用户
    updateCustomerUser: (params: postLlmUserUpdateCustomerUserBodyParams) => {
        return api.sendPostRequest('/llm/user/updateCustomerUser', params)
    },
    // 用户修改密码
    modifyPw: (params: ChangePwParams) => {
        return api.sendPostRequest('/llm/user/modifyPw', params)
    },
    // 用户注销登录
    loginOut: () => {
        return api.sendPostRequest('/llm/user/loginOut')
    },
    //修改手机号
    modifyMobile: (params: any) => {
        return api.sendPostRequest('/llm/user/modifyMobile', params)
    },
    getQrcode: (params: any) => {
        return api.sendGetRequest('/llm/user/getQrcode', params)
    },
    //获取扫码登录状态
    checkScanLogin: (params: any) => {
        return api.sendGetRequest('/llm/user/checkScanLogin', params)
    },
    //埋点
    report: (params: any) => {
        return api.sendPostRequest('/llm/behavior/tracking', params)
    }
}

export interface postLlmUserUpdateCustomerUserBodyParams {
    mobile?: string // 手机
    email?: string // 邮箱
    name?: string // 名称
    status?: number // 状态：1-冻结 2-正常
    avatar?: string // 状态：1-冻结 2-正常
    id: string // id
}

export interface LoginParams {
    account: string
    password: string
    mobile: string
    code: string
    type: number
}

export interface LoginSummary {
    token: string
    user_info: UserInfoResult
}
export interface UserInfoResult {
    avatar: string // 头像
    company_name: string // 公司名称
    createTime: string // 创建时间
    customer_id: string // 客户id
    email: string // 邮箱
    id: string // 用户id
    is_deleted: number // 是否删除
    is_open_water: number // 去水，1是、2否
    last_login_time: string // 最后登录时间
    mobile: string // 手机号
    name: string // 名称
    rights: string[] // 权益树
    rights_active_date: string // 权益生效时间
    rights_expire_date: string // 权益到期时间
    status: number // 状态
    updateTime: string // 更新时间
    industry: string[] // 开通行业
}
export interface ChangePwParams {
    old_password: string
    new_password: string
}
export interface ResetPwParams {
    email: string
}

export interface ResetPasswordParams {
    id: string
}

export interface postOfficialAddTasteUserBodyParams {
    name: string // 姓名
    mobile: string // 手机号
    email: string // 邮箱
    remark?: string // 备注
    company_name: string // 公司名称
    captcha: string // 手机验证码
    product_type?: number // 产品类型，1、MIP，2、LLM， 默认为1
}

// @ts-ignore
window.__config = config
